{
  "required": "この項目は必須です。",
  "tooShort": "{min} 文字以上で入力してください。",
  "tooLong": "{max} 文字以内で入力してください。",
  "invalidEmail": "有効なメールアドレスを入力してください。",
  "invalidNumber": "有効な数値を入力してください。",
  "minAmount": "{amount} 以上を入力してください。"
}
